<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>

        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <!-- Start:: Name Input -->
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.packageNumber')"
                v-model.trim="filterOptions.search"
              />
              <!-- End:: Name Input -->
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button
                class="reset_btn"
                type="button"
                :disabled="isWaitingRequest"
                @click="resetFilter"
              >
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Tabs Navigation =========== -->
      <div class="packages_tabs">
        <button
          type="button"
          class="packages_tab"
          :class="{ 'packages_tab--active': activeTab === 'packages' }"
          @click="activeTab = 'packages'"
        >
          <span class="packages_tab__icon">
            <i class="fal fa-boxes"></i>
          </span>
          <span class="packages_tab__content">
            <span class="packages_tab__title">{{ $t("PLACEHOLDERS.packages") }}</span>
            <span class="packages_tab__subtitle">{{ $t("PLACEHOLDERS.packages_tab_desc") }}</span>
          </span>
        </button>

        <button
          type="button"
          class="packages_tab packages_tab--errors"
          :class="{ 'packages_tab--active': activeTab === 'errors' }"
          @click="activeTab = 'errors'"
        >
          <span class="packages_tab__icon">
            <i class="fal fa-exclamation-circle"></i>
          </span>
          <span class="packages_tab__content">
            <span class="packages_tab__title">{{ $t("TITLES.errorReports") }}</span>
            <span class="packages_tab__subtitle">{{ $t("PLACEHOLDERS.errors_tab_desc") }}</span>
          </span>
          <span v-if="failedImports.length" class="packages_tab__badge">
            {{ failedImports.length }}
          </span>
        </button>
      </div>
      <!--  =========== End:: Tabs Navigation =========== -->

      <!--  =========== Start:: Packages Tab =========== -->
      <div v-show="activeTab === 'packages'">
        <!--  =========== Start:: Table Title =========== -->
        <div class="table_title_wrapper">
          <div class="title_text_wrapper">
            <h5>{{ $t("PLACEHOLDERS.packages") }}</h5>
            <button
              v-if="!filterFormIsActive"
              class="filter_toggler"
              @click.stop="filterFormIsActive = !filterFormIsActive"
            >
              <i class="fal fa-search"></i>
            </button>
          </div>

          <div class="title_route_wrapper packages_actions">
            <div class="packages_actions__group">
              <button
                type="button"
                class="packages_action_btn packages_action_btn--secondary"
                @click="downloadTemplate"
              >
                <i class="fal fa-download"></i>
                <span>{{ $t("BUTTONS.download_template") }}</span>
              </button>

              <label
                for="excelUpload"
                class="packages_action_btn packages_action_btn--upload"
                :class="{ 'packages_action_btn--loading': isUploadingExcel }"
              >
                <i
                  :class="isUploadingExcel ? 'fal fa-spinner fa-spin' : 'fal fa-upload'"
                ></i>
                <span>{{ $t("BUTTONS.upload_excel") }}</span>
              </label>
              <input
                id="excelUpload"
                type="file"
                accept=".xlsx,.xls"
                @change="handleExcelUpload"
                class="packages_file_input"
                :disabled="isUploadingExcel"
              />
            </div>

            <button
              type="button"
              class="packages_action_btn packages_action_btn--primary"
              @click="$router.push('/packages/create')"
            >
              <i class="fal fa-plus"></i>
              <span>{{ $t("TITLES.addPackage") }}</span>
            </button>
          </div>
        </div>

  
        <!--  =========== End:: Table Title =========== -->

        <!--  =========== Start:: Data Table =========== -->
        <v-data-table
          class="thumb"
          :loading="loading"
          :loading-text="$t('TABLES.loadingData')"
          :search="searchValue"
          :headers="tableHeaders"
          :items="tableRows"
          item-class="ltr"
          :items-per-page="paginations.items_per_page"
          hide-default-footer
        >
          <template v-slot:[`item.id`]="{ index }">
            {{
              (paginations.current_page - 1) * paginations.items_per_page +
              index +
              1
            }}
          </template>
          <!-- Start:: No Data State -->
          <template v-slot:no-data>
            {{ $t("TABLES.noData") }}
          </template>
          <!-- Start:: No Data State -->

          <!-- Start:: Status -->
          <template v-slot:[`item.status.text`]="{ item }">
            <v-chip
              v-if="item.status"
              :color="getPackageStatusColor(item.status.value)"
              text-color="white"
              small
              class="package_status_chip"
            >
              {{ item.status.text || item.status.value || "-" }}
            </v-chip>
            <span v-else>-</span>
          </template>
          <!-- End:: Status -->

          <!-- Start:: Actions -->
          <template v-slot:[`item.actiosn`]="{ item }">
            <div class="actions">
              <a-tooltip
                placement="bottom"
                v-if="$can('packages delete', 'packages')"
              >
                <template slot="title">
                  <span>{{ $t("BUTTONS.delete") }}</span>
                </template>
                <button class="btn_delete" @click="selectDeleteItem(item)">
                  <i class="fal fa-trash-alt"></i>
                </button>
              </a-tooltip>
              <!-- <a-tooltip
              placement="bottom"
            >
              <template slot="title">
                <span>{{ $t("BUTTONS.edit") }}</span>
              </template>

              <button class="btn_edit" @click="editItem(item)">
                <i class="fal fa-edit"></i>
              </button>
            </a-tooltip> -->
              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ $t("BUTTONS.show") }}</span>
                </template>
                <button class="btn_show" @click="showItem(item)">
                  <i class="fal fa-eye"></i>
                </button>
              </a-tooltip>

              <!-- <template v-else>
              <i
                class="fal fa-lock-alt fs-5 blue-grey--text text--darken-1"
              ></i>
            </template> -->
            </div>
          </template>
          <!-- End:: Actions -->

          <!-- ======================== Start:: Dialogs ======================== -->
          <template v-slot:top>
            <!-- Start:: Image Modal -->
            <image-modal
              v-if="dialogImage"
              :modalIsOpen="dialogImage"
              :modalImage="selectedItemImage"
              @toggleModal="dialogImage = !dialogImage"
            />
            <!-- End:: Image Modal -->

            <!-- Start:: Description Modal -->

            <description-modal
              v-if="dialogDescription"
              :modalIsOpen="dialogDescription"
              :modalDesc="selectedDescriptionTextToShow"
              @toggleModal="dialogDescription = !dialogDescription"
            />
            <!-- End:: Description Modal -->

            <!-- Start:: Delete Modal -->
            <v-dialog v-model="dialogDelete">
              <v-card>
                <v-card-title
                  class="text-h5 justify-center"
                  v-if="itemToDelete"
                >
                  {{
                    $t("TITLES.DeleteConfirmingMessage", {
                      name: itemToDelete.name,
                    })
                  }}
                </v-card-title>
                <v-card-actions>
                  <v-btn class="modal_confirm_btn" @click="confirmDeleteItem">{{
                    $t("BUTTONS.ok")
                  }}</v-btn>

                  <v-btn
                    class="modal_cancel_btn"
                    @click="dialogDelete = false"
                    >{{ $t("BUTTONS.cancel") }}</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- End:: Delete Modal -->
          </template>
          <!-- ======================== End:: Dialogs ======================== -->
        </v-data-table>
        <!--  =========== End:: Data Table =========== -->
      </div>
      <!--  =========== End:: Packages Tab =========== -->

      <!--  =========== Start:: Errors Tab =========== -->
      <div v-show="activeTab === 'errors'">
        <!--  =========== Start:: Error Reports Title =========== -->
        <div class="table_title_wrapper">
          <div class="title_text_wrapper">
            <h5>{{ $t("TITLES.errorReports") }}</h5>
          </div>
        </div>
        <!--  =========== End:: Error Reports Title =========== -->

        <!--  =========== Start:: Failed Imports Table =========== -->
        <v-data-table
          class="thumb"
          :loading="loadingFailedImports"
          :loading-text="$t('TABLES.loadingData')"
          :headers="failedImportsHeaders"
          :items="failedImports"
          item-class="ltr"
          hide-default-footer
        >
          <template v-slot:[`item.filename`]="{ item }">
            <strong>{{ item.filename }}</strong>
          </template>

          <template v-slot:[`item.last_modified`]="{ item }">
            {{ formatDate(item.last_modified) }}
          </template>

          <template v-slot:[`item.size`]="{ item }">
            {{ formatFileSize(item.size) }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="actions">
              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ $t("BUTTONS.download") }}</span>
                </template>
                <span>
                  <button
                    class="btn_show"
                    @click="downloadFailedImportFile(item)"
                    :disabled="isDownloadingFailedFile"
                  >
                    <i class="fal fa-download"></i></button
                ></span>
              </a-tooltip>
            </div>
          </template>

          <!-- Start:: No Data State -->
          <template v-slot:no-data>
            {{ $t("TABLES.noData") }}
          </template>
          <!-- End:: No Data State -->
        </v-data-table>
        <!--  =========== End:: Failed Imports Table =========== -->
      </div>
      <!--  =========== End:: Errors Tab =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template v-if="activeTab === 'packages'">
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getPackageStatusColor } from "@/utils/packageStatus";

export default {
  name: "Allpackages",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),

    activeStatuses() {
      return [
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: 0,
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Tab Navigation Data
      activeTab: "packages",
      // End:: Tab Navigation Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        search: null,
      },
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.package_number"),
          value: "package_number",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.name"),
          value: "user.name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.phone"),
          value: "mobile",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.address"),
          value: "address",
          sortable: false,
          align: "center",
        },

        {
          text: this.$t("PLACEHOLDERS.status"),
          value: "status.text",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("TABLES.Admins.actions"),
          value: "actiosn",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      capacities: [],
      // End:: Table Data

      // Start:: Failed Imports Data
      loadingFailedImports: false,
      isDownloadingFailedFile: false,
      failedImports: [],
      failedImportsHeaders: [
        {
          text: this.$t("PLACEHOLDERS.filename"),
          value: "filename",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.uploadDate"),
          value: "last_modified",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.fileSize"),
          value: "size",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("TABLES.Admins.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      // End:: Failed Imports Data

      // Start:: Dialogs Control Data
      dialogImage: false,
      selectedItemImage: null,
      dialogDescription: false,
      selectedDescriptionTextToShow: "",
      dialogDelete: false,
      itemToDelete: null,
      // End:: Dialogs Control Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 10,
      },
      // End:: Pagination Data

      regions: [],
      cites: [],

      // Start:: Bulk Upload Data
      isUploadingExcel: false,
      // End:: Bulk Upload Data
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change

    // Start:: Active Tab Watcher To Refresh Data
    activeTab(newTab) {
      if (newTab === "errors") {
        this.getFailedImports();
      } else if (newTab === "packages") {
        this.setTableRows();
      }
    },
    // End:: Active Tab Watcher To Refresh Data
  },

  methods: {
    getPackageStatusColor,

    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({ path: "/packages/all", query: { page: 1 } });
      }
      this.setTableRows();
    },
    async resetFilter() {
      this.filterOptions.search = null;

      if (this.$route.query.page !== "1") {
        await this.$router.push({ path: "/packages/all", query: { page: 1 } });
      }
      this.setTableRows();
    },
    // End:: Handel Filter

    // Start:: Download Excel Template
    async downloadTemplate() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "packages/download-template",
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "packages_template.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success(this.$t("MESSAGES.downloadedSuccessfully"));
      } catch (error) {
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.failed")
        );
      }
    },
    // End:: Download Excel Template

    // Start:: Handle Excel Upload
    async handleExcelUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // // Validate file type
      // const validTypes = [
      //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      //   "application/vnd.ms-excel",
      // ];

      // if (!validTypes.includes(file.type)) {
      //   this.$message.error("يرجى رفع ملف Excel صحيح (.xlsx أو .xls)");
      //   event.target.value = "";
      //   return;
      // }

      // // Validate file size (max 5MB)
      // const maxSize = 5 * 1024 * 1024; // 5MB
      // if (file.size > maxSize) {
      //   this.$message.error("حجم الملف كبير جداً. الحد الأقصى 5 ميجابايت");
      //   event.target.value = "";
      //   return;
      // }

      // // Validate file is not empty
      // if (file.size === 0) {
      //   this.$message.error("الملف فارغ. يرجى رفع ملف يحتوي على بيانات");
      //   event.target.value = "";
      //   return;
      // }

      const formData = new FormData();
      formData.append("file", file);

      this.isUploadingExcel = true;
      try {
        const res = await this.$axios({
          method: "POST",
          url: "packages/import",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.isUploadingExcel = false;
        event.target.value = "";

        // Check response data
        if (!res.data) {
          this.$message.error("استجابة غير صحيحة من الخادم");
          return;
        }

        // Show success message
        this.$message.success(
          this.$t("MESSAGES.uploadedSuccessfully") || "تم رفع الملف بنجاح"
        );

        // Refresh the table and failed imports
        this.setTableRows();
        await this.getFailedImports();

        // Switch to errors tab if there are failed imports
        if (this.failedImports.length > 0) {
          this.$message.warning(
            "يوجد بعض الصفوف التي بها أخطاء. يرجى التحقق من تقرير الأخطاء."
          );
          this.activeTab = "errors";
        }
      } catch (error) {
        this.isUploadingExcel = false;
        event.target.value = "";

        // Enhanced error handling
        if (error.response?.data) {
          const errorData = error.response.data;

          // Handle validation errors
          if (errorData.errors) {
            let errorMessage = "فشل رفع الملف بسبب أخطاء في البيانات:\n\n";

            // Check if errors is an array
            if (Array.isArray(errorData.errors)) {
              errorData.errors.forEach((err) => {
                const rowNum = err.row || err.line || "غير محدد";
                const errorMsg = err.message || err.error || "خطأ غير معروف";

                // Check for missing required fields
                if (errorMsg.includes("name") || errorMsg.includes("الاسم")) {
                  errorMessage += `• الصف ${rowNum}: حقل الاسم مطلوب\n`;
                } else if (
                  errorMsg.includes("mobile") ||
                  errorMsg.includes("الجوال")
                ) {
                  errorMessage += `• الصف ${rowNum}: حقل رقم الجوال مطلوب\n`;
                } else if (
                  errorMsg.includes("address") ||
                  errorMsg.includes("العنوان")
                ) {
                  errorMessage += `• الصف ${rowNum}: حقل العنوان مطلوب\n`;
                } else if (
                  errorMsg.includes("weight") ||
                  errorMsg.includes("الوزن")
                ) {
                  errorMessage += `• الصف ${rowNum}: حقل الوزن مطلوب\n`;
                } else if (
                  errorMsg.includes("width") ||
                  errorMsg.includes("العرض")
                ) {
                  errorMessage += `• الصف ${rowNum}: حقل العرض مطلوب\n`;
                } else if (
                  errorMsg.includes("height") ||
                  errorMsg.includes("الارتفاع")
                ) {
                  errorMessage += `• الصف ${rowNum}: حقل الارتفاع مطلوب\n`;
                } else if (
                  errorMsg.includes("length") ||
                  errorMsg.includes("الطول")
                ) {
                  errorMessage += `• الصف ${rowNum}: حقل الطول مطلوب\n`;
                } else {
                  errorMessage += `• الصف ${rowNum}: ${errorMsg}\n`;
                }
              });
            }
            // Check if errors is an object with field names
            else if (typeof errorData.errors === "object") {
              Object.keys(errorData.errors).forEach((field) => {
                const fieldErrors = Array.isArray(errorData.errors[field])
                  ? errorData.errors[field]
                  : [errorData.errors[field]];

                // Map field names to Arabic
                const fieldNames = {
                  name: "الاسم",
                  mobile: "رقم الجوال",
                  address: "العنوان",
                  weight: "الوزن",
                  width: "العرض",
                  height: "الارتفاع",
                  length: "الطول",
                  file: "الملف",
                };
                const arabicFieldName = fieldNames[field] || field;

                fieldErrors.forEach((err) => {
                  errorMessage += `• ${arabicFieldName}: ${err}\n`;
                });
              });
            } else {
              errorMessage += errorData.message || "خطأ غير معروف";
            }

            errorMessage += "\nملحوظة: جميع الحقول مطلوبة ماعدا الملاحظات";

            this.$message.error(errorMessage);
          }
          // Handle missing required fields
          else if (errorData.message) {
            let errorMsg = errorData.message;

            // Check for common validation errors
            if (errorMsg.includes("required") || errorMsg.includes("مطلوب")) {
              errorMsg = "يوجد حقول مطلوبة مفقودة في الملف:\n" + errorMsg;
              errorMsg +=
                "\n\nالحقول المطلوبة: الاسم، رقم الجوال، العنوان، الوزن، العرض، الارتفاع، الطول";
            } else if (
              errorMsg.includes("invalid") ||
              errorMsg.includes("غير صحيح")
            ) {
              errorMsg = "يوجد بيانات غير صحيحة في الملف:\n" + errorMsg;
            } else if (
              errorMsg.includes("format") ||
              errorMsg.includes("تنسيق")
            ) {
              errorMsg = "تنسيق الملف غير صحيح. يرجى استخدام النموذج المحمل";
            } else if (
              errorMsg.includes("empty") ||
              errorMsg.includes("فارغ")
            ) {
              errorMsg =
                "الملف لا يحتوي على بيانات صحيحة. الحقول المطلوبة: الاسم، رقم الجوال، العنوان، الوزن، العرض، الارتفاع، الطول";
            }

            this.$message.error(errorMsg);
          } else {
            this.$message.error("فشل رفع الملف. يرجى التحقق من صحة البيانات");
          }
        } else if (error.request) {
          this.$message.error("فشل الاتصال بالخادم. يرجى المحاولة مرة أخرى");
        } else {
          this.$message.error("حدث خطأ غير متوقع: " + error.message);
        }
      }
    },
    // End:: Handle Excel Upload

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get packages
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    async setTableRows() {
      this.loading = true;
      try {
        const params = {
          page: this.paginations.current_page,
          search: this.filterOptions.search,
          // capacity: this.filterOptions.capacity?.id,
          // is_active: this.filterOptions.is_active?.value,
          // "created_at[0]": this.filterOptions.from_date,
          // "created_at[1]": this.filterOptions.to_date,
        };
        let res = await this.$axios({
          method: "GET",
          url: "packages",
          params: params,
        });

        this.loading = false;
        this.tableRows = res.data.data;
        this.paginations.last_page = res.data.meta.last_page;
        this.paginations.items_per_page = res.data.meta.per_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows
    showReplayModal(replay) {
      this.dialogDescription = true;
      this.selectedDescriptionTextToShow = replay;
    },

    // Start:: Control Modals
    showImageModal(image) {
      this.dialogImage = true;
      this.selectedItemImage = image;
    },
    // End:: Control Modals
    // Start:: Change Activation Status
    async changeActivationStatus(item) {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      // REQUEST_DATA.append("_method", "PUT");
      try {
        await this.$axios({
          method: "POST",
          url: `packages/activate/${item.id}`,
          data: REQUEST_DATA,
        });
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.changeActivation"));
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Change Activation Status

    // ==================== Start:: Crud ====================
    // ===== Start:: End
    editItem(item) {
      this.$router.push({ path: `/packages/edit/${item.id}` });
    },
    showItem(item) {
      this.$router.push({ path: `/packages/show/${item.id}` });
    },
    // ===== End:: End

    // ===== Start:: Delete
    selectDeleteItem(item) {
      this.dialogDelete = true;
      this.itemToDelete = item;
    },

    async confirmDeleteItem() {
      try {
        await this.$axios({
          method: "DELETE",
          url: `packages/${this.itemToDelete.id}`,
        });
        this.dialogDelete = false;
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
      } catch (error) {
        this.dialogDelete = false;
        this.$message.error(error.response.data.message);
      }
    },
    // ===== End:: Delete
    // ==================== End:: Crud ====================

    // ==================== Start:: Failed Imports ====================
    // Start:: Get Failed Imports
    async getFailedImports() {
      this.loadingFailedImports = true;
      try {
        const res = await this.$axios({
          method: "GET",
          url: "packages/list-import-failures",
        });

        this.loadingFailedImports = false;
        this.failedImports = res.data.data || [];
      } catch (error) {
        this.loadingFailedImports = false;
        console.log(
          "Error fetching failed imports:",
          error.response?.data?.message
        );
      }
    },
    // End:: Get Failed Imports

    // Start:: Download Failed Import File
    async downloadFailedImportFile(item) {
      this.isDownloadingFailedFile = true;
      try {
        const res = await this.$axios({
          method: "GET",
          url: "packages/download-import-failures",
          params: {
            filename: item.filename,
          },
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", item.filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success(this.$t("MESSAGES.downloadedSuccessfully"));
      } catch (error) {
        console.log(error.message, error.response.data);
        this.$message.error(
          error.response?.message || this.$t("MESSAGES.failed")
        );
      } finally {
        this.isDownloadingFailedFile = false;
      }
    },
    // End:: Download Failed Import File

    // Start:: Format Date Helper
    formatDate(dateString) {
      if (!dateString) return "-";

      const date = new Date(dateString.replace(" ", "T"));

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // End:: Format Date Helper

    // Start:: Format File Size Helper
    formatFileSize(bytes) {
      if (!bytes) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
    },
    // End:: Format File Size Helper
    // ==================== End:: Failed Imports ====================
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    this.getFailedImports();
    // this.getCapacities()
    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.packages_tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
  margin-bottom: 1.25rem;
  padding: 0.5rem;
  background: var(--theme_main_bg_clr);
  border: 1px solid var(--border_clr);
  border-radius: 16px;
}

.packages_tab {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.9rem 1rem;
  border: 1px solid var(--border_clr);
  border-radius: 12px;
  background: var(--theme_second_bg_clr);
  color: var(--theme_text_clr);
  text-align: start;
  cursor: pointer;
  transition: all 0.25s ease;

  &:hover {
    border-color: rgba(239, 52, 5, 0.35);
    transform: translateY(-1px);
  }

  &--active {
    background: var(--main_theme_clr);
    border-color: var(--main_theme_clr);
    color: var(--white_clr);
    box-shadow: 0 8px 22px var(--soft_main_theme_clr);

    .packages_tab__icon {
      background: rgba(255, 255, 255, 0.18);
      color: var(--white_clr);
    }

    .packages_tab__subtitle {
      color: rgba(255, 255, 255, 0.85);
    }
  }

  &--errors.packages_tab--active {
    background: var(--mid_red_clr);
    border-color: var(--mid_red_clr);
    box-shadow: 0 8px 22px rgba(220, 53, 69, 0.25);
  }

  &__icon {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    background: var(--soft_main_theme_clr);
    color: var(--main_theme_clr);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 1rem;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    min-width: 0;
  }

  &__title {
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1.3;
  }

  &__subtitle {
    font-size: 0.78rem;
    color: var(--theme_secondary_text_clr);
    line-height: 1.4;
  }

  &__badge {
    position: absolute;
    top: 10px;
    inset-inline-end: 10px;
    min-width: 24px;
    height: 24px;
    padding: 0 7px;
    border-radius: 999px;
    background: var(--mid_red_clr);
    color: var(--white_clr);
    font-size: 0.75rem;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &--active &__badge {
    background: var(--white_clr);
    color: var(--mid_red_clr);
  }
}

.packages_actions {
  align-items: center;
  gap: 0.75rem;

  &__group {
    display: flex;
    flex-wrap: wrap;
    gap: 0.65rem;
  }
}

::v-deep .packages_actions {
  a,
  button,
  label {
    background-image: none !important;
  }
}

.packages_action_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.65rem 1.05rem;
  border-radius: 10px;
  border: 1px solid transparent;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  white-space: nowrap;
  line-height: 1.2;

  span,
  i {
    color: inherit;
  }

  i {
    font-size: 0.9rem;
  }

  &--primary {
    background: var(--main_theme_clr) !important;
    color: var(--white_clr) !important;
    border-color: var(--main_theme_clr) !important;

    &:hover {
      opacity: 0.92;
      transform: translateY(-1px);
      color: var(--white_clr) !important;
    }
  }

  &--secondary {
    background: var(--theme_second_bg_clr);
    color: var(--theme_text_clr);
    border-color: var(--border_clr);

    &:hover {
      border-color: var(--main_theme_clr);
      color: var(--main_theme_clr);
    }
  }

  &--upload {
    background: var(--soft_main_theme_clr);
    color: var(--main_theme_clr);
    border-color: rgba(239, 52, 5, 0.2);

    &:hover {
      background: var(--main_theme_clr);
      color: var(--white_clr);
    }
  }

  &--loading {
    opacity: 0.75;
    pointer-events: none;
  }
}

.packages_file_input {
  display: none;
}

.packages_upload_hint {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  margin: -0.5rem 0 1.25rem;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: var(--soft_main_theme_clr);
  border: 1px solid rgba(239, 52, 5, 0.15);
  color: var(--theme_text_clr);
  font-size: 0.85rem;
  line-height: 1.6;

  i {
    color: var(--main_theme_clr);
    margin-top: 0.15rem;
    flex-shrink: 0;
  }
}

.package_status_chip {
  font-weight: 600;
  min-width: 88px;
  justify-content: center;
}

@media (max-width: 768px) {
  .packages_tabs {
    grid-template-columns: 1fr;
  }

  .packages_actions {
    width: 100%;
    flex-direction: column;
    align-items: stretch;

    &__group {
      width: 100%;
    }
  }

  .packages_action_btn {
    width: 100%;
  }
}
</style>
